import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { LOCAL_STORAGE } from '@fmnts/common/storage';
import { RocketComponent } from '@fmnts/components/corporate-identity';
import { FmntsIconsModule } from '@fmnts/components/icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
type LoadingIndicatorVariant = 'fontawesome' | 'rocket' | 'donut';

/**
 * Displays a loading indicator
 */
@Component({
  selector: 'fmnts-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RocketComponent, FmntsIconsModule],
})
export class LoadingIndicatorComponent {
  @HostBinding('class')
  protected readonly componentClass = 'fmnts-loading-indicator';

  protected readonly iconSpinner = faSpinnerThird;
  readonly #localStorage = inject(LOCAL_STORAGE);

  /**
   * Size of the indicator
   */
  @Input() size: RocketComponent['size'] = 'md';
  /**
   * Color variant to use
   */
  @Input() color: RocketComponent['color'] = 'primary';
  /**
   * Loading indicator variant to use
   */
  @Input() variant: LoadingIndicatorVariant = 'fontawesome';

  public spinnerSize(): SizeProp {
    switch (this.size) {
      case 'xs':
        return '1x';
      case 'sm':
        return '2x';
      case 'lg':
        return '4x';
      default:
        return '3x';
    }
  }
  public onDonutFound(): void {
    window.alert('Congratulations! You found a donut!');
    this.#localStorage.setItem('donut-found', 'true');
  }
}
